import React from 'react'
import styles from './TopBar.module.css'

import IconClose from '../../../../../assets/icons/IconClose'

const TopBar = ({
    onClose,
    maxProgress,
    progress,
}) => {
    return (
        <div className={styles.container}>
            <IconClose 
                onClick={onClose}
                size={32} 
                className={styles.closeButton} />
            <div className={styles.progress}>
                <div className={styles.innerProgress} style={{width: !maxProgress || !progress ? 0 : ((progress / maxProgress) * 100) + '%'}}/>
            </div>
            <div style={{ width: '48px' }} />
        </div>
    )
}

export default TopBar
